"use strict";

exports.__esModule = true;
exports.default = void 0;
var _actions = _interopRequireDefault(require("./actions"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  Name: {
    displayName: 'Name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  StartDate: {
    displayName: 'Start date',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  EndDate: {
    displayName: 'End date',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  Duration: {
    displayName: 'Duration',
    type: 'Duration',
    rules: {
      days: true,
      hours: false,
      minutes: false,
      seconds: false
    },
    value: '',
    sortable: true,
    filterable: false
  },
  /* 
  isValid: {
    displayName: 'Is valid',
    type: 'Bool',
    guarded: true,
  sortable: true,
  filterable: true,
  },
  isActive: {
    displayName: 'Is active',
    type: 'Bool',
    guarded: true,
  sortable: true,
  filterable: true,
  },
  ShouldBeActive: {
    displayName: 'Should be active',
    type: 'Bool',
    guarded: true,
  sortable: true,
  filterable: true,
  }, */
  ActivationOption: {
    displayName: 'Activation condition',
    type: 'MultiEnum',
    options: {
      0: 'None',
      1: 'HasStartDate',
      2: 'HasEndDate',
      4: 'HasDuration',
      8: 'DurationEndsAtEnd'
    },
    rules: [],
    value: 0,
    sortable: true,
    filterable: false
  },
  LicenseGroups: {
    displayName: 'Assigned groups',
    type: 'Join',
    entities: {
      local: 'License',
      join: 'LicenseGroups',
      foreign: 'Group',
      displayName: 'Name',
      filterString: value => `Name != null and Name.Contains("${value}")`,
      getDisplayName: entity => `${entity.Name}`
    },
    add: _actions.default.addGroup,
    drop: _actions.default.dropGroup,
    sortable: false,
    filterable: false
  },
  UserLicenses: {
    displayName: 'Users',
    type: 'Join',
    entities: {
      local: 'License',
      join: 'UserLicenses',
      foreign: 'User',
      displayName: `Id`,
      filterString: value => `(GivenName != null and GivenName.Contains("${value}")) or (FamilyName != null and FamilyName.Contains("${value}")) or (Email != null and Email.Contains("${value}"))`,
      getDisplayName: entity => entity.Email === undefined ? `${entity.GivenName} ${entity.FamilyName}` : `${entity.GivenName} ${entity.FamilyName} - ${entity.Email}`
    },
    add: _actions.default.addUser,
    drop: _actions.default.dropUser,
    sortable: false,
    filterable: false
  }
};
module.exports = exports.default;